// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_3WGiK","isUploading":"_3HLyE","rotate":"_1EjFG","dash":"_2vWKH"};